import { useState, useEffect } from "react";
import { Menu, X, Phone, MessageSquare } from "lucide-react";
import { BRAND, NAV } from "@/data/site";
import { telHref, smsHref, scrollTo } from "@/lib/actions";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24 lg:h-32">
          <a href="#home" onClick={(e) => handleNav(e, "#home")} data-testid="header-logo" className="flex items-center">
            <img src={BRAND.logo} alt="Cars With Malcolm" className="h-20 lg:h-28 w-auto object-contain" />
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNav(e, item.href)}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className="text-sm font-medium uppercase tracking-wide text-gray-300 hover:text-[#C8102E] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={telHref}
              data-testid="header-call-btn"
              className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-white border border-white/20 rounded-sm hover:bg-white/10 transition-all hover:-translate-y-0.5"
            >
              <Phone size={16} /> Call
            </a>
            <a
              href={smsHref}
              data-testid="header-text-btn"
              className="flex items-center gap-2 px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-white bg-[#C8102E] rounded-sm hover:bg-[#A00D25] transition-all hover:-translate-y-0.5 shadow-lg shadow-[#C8102E]/30"
            >
              <MessageSquare size={16} /> Text Malcolm
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNav(e, item.href)}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              className="block text-base font-medium uppercase tracking-wide text-gray-200 hover:text-[#C8102E]"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
